import { Modules } from '../../util/modules'
import { RouteConfig } from 'vue-router'
import { requireAuthAndLocation } from '../auth'

const PaymentSettingsWrapper = () => import('@/pmd/pages/payments/settings/PaymentSettings.vue')

const PaymentReceiptSettings = () => import('@/pmd/pages/payments/settings/PaymentReceiptSettings.vue')

const PaymentTaxSettings = () => import('@/pmd/pages/payments/settings/TaxSettings.vue')

const PaymentSubscriptionSettings = () => import('@/pmd/pages/payments/settings/PaymentSubscriptionSettings.vue')

const EcommerceNotificationSettings = () => import('@/pmd/pages/payments/settings/EcommerceNotificationSettings.vue')

const StoreShippingSettings = () => import('@/pmd/pages/payments/settings/StoreShippingSettings.vue')

const StoreShippingOriginSettings = () => import('@/pmd/pages/payments/settings/StoreShippingOriginSettings.vue')

const MiscellaneousCharges = () => import('@/pmd/pages/payments/settings/MiscellaneousCharges.vue')

const PaymentLinksSettings = () =>
    import('@/pmd/pages/payments/settings/PaymentLinksSettings.vue')

export const PaymentsRoute: RouteConfig[] = [
  {
    path: 'payments/settings',
    name: 'payment-settings',
    component: PaymentSettingsWrapper,
    beforeEnter: requireAuthAndLocation,
    children: [
      {
        path: 'receipts',
        name: 'payment-settings-receipts',
        component: PaymentReceiptSettings,
        beforeEnter: requireAuthAndLocation,
        meta: { translations: [Modules.Payments] },
      },
      {
        path: 'taxes',
        name: 'payment-settings-taxes',
        component: PaymentTaxSettings,
        beforeEnter: requireAuthAndLocation,
        meta: { translations: [Modules.Payments] },
      },
      {
        path: 'notifications',
        name: 'payment-settings-notifications',
        component: EcommerceNotificationSettings,
        beforeEnter: requireAuthAndLocation,
        meta: { translations: [Modules.Payments] },
      },
      {
        path: 'shipping',
        name: 'payment-settings-shipping',
        component: StoreShippingSettings,
        beforeEnter: requireAuthAndLocation,
        meta: { translations: [Modules.Payments] },
      },
      {
        path: 'shipping-origin',
        name: 'payment-settings-shipping-origin',
        component: StoreShippingOriginSettings,
        beforeEnter: requireAuthAndLocation,
        meta: { translations: [Modules.Payments] },
      },
      {
        path: 'subscriptions',
        name: 'payment-settings-subscriptions',
        component: PaymentSubscriptionSettings,
        beforeEnter: requireAuthAndLocation,
        meta: { translations: [Modules.Payments] },
      },
            {
                path: 'payment-links',
                name: 'payment-settings-payment-links',
                component: PaymentLinksSettings,
                beforeEnter: requireAuthAndLocation,
                meta: { translations: [Modules.Payments] },
            },
      {
        path: 'miscellaneous-charges',
        name: 'payment-settings-misc-charges',
        component: MiscellaneousCharges,
        beforeEnter: requireAuthAndLocation,
        meta: { translations: [Modules.Payments] },
      },
    ],
  },
]
